<template>
    <v-card elevation="2" shaped class="ma-1">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Paramètres d'Envoi d'email </v-toolbar-title>
      </v-toolbar>

      <div>
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Corp du mail </v-tab>
          <v-tab> requete pour e-mails et crochets </v-tab>
          <v-tab> Documents attachés </v-tab>
          <v-tab> Envoi groupé </v-tab>
          <v-tabs-items v-model="tab" class="pl-4">

            <v-tab-item>
              <v-row>
                <v-col class="ma-1">
                    Définissez le corp et l'objet du mail. Soit à partir de champs d'une table, soit directement dans le module
                    <Select
                    :item="{name: 'Quel corp de mail allez-vous choisir ?',value: 'type',liste: [{ text: 'sélectionner', value: '' },{ text: 'Construire mon mail dans ce module', value: 'manual' },{ text: 'Choisir à partir d\'un élément d\'une table', value: 'fromfield' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="cc"
                    :valField="displays.params.type"
                    />


                    <div v-if="displays.params.type == 'manual'">

                <Autocomplete
                :item="{name: 'Sélectionnez la page qui fera l\'objet de la bibliothèque dans l\'éditeur',value: 'type',liste: listPages,
                defaultprops:{ show: true }}"
                type="form"
                :change="(item,value,select) => { displays.params.manual.pagebibli = value[select]; $emit('recepVal',displays) }"
                :valField="displays.params.manual.pagebibli"
                />
                <TextField
                :item="{ name: 'Objet', value: 'objet' ,defaultprops:{ show: true }}"
                :valField="displays.params.manual.objet"
                :keyup="(item,model)=> { displays.params.manual.objet = model; $emit('recepVal',displays); }"
                /> 
                <TextField
                :item="{ name: 'Titre du bouton', value: 'title' ,defaultprops:{ show: true }}"
                :valField="displays.params.manual.title"
                :keyup="(item,model)=> { displays.params.manual.title = model; $emit('recepVal',displays); }"
                />
                    <texteditor
                    v-if="displays.params.manual.pagebibli"
                    :page="page"
                    :item="{name: 'corp du mail',value: 'corp',
                    
                    defaultprops:{ show: true},
                    otherparams:{menueditor:[{namelist:'élements','icon':'',list:[{type:'menuitem','text':'médias',link:displays.params.manual.pagebibli}]}]}
                    }"
                    :keyup="(item,value) => { displays.params.manual.corp = value }"
                    :valField="displays.params.manual.corp"
                    />
                    </div>

                    <div v-if="displays.params.type == 'fromfield'">
                        <Autocomplete
                            :item="{ 
                                name: 'Sélectionnez la table sujete au corp du mail', 
                                value: 'table', 'liste': itemTableListe,
                                defaultprops:{ show: true, chips: false, deletablechips: false, modelRules: [v => !!v || 'Ce champ doit etre renseigné'] }
                            }" :valField="displays.params.fromfield.table" :change="(item,value,select) => { displays.params.fromfield.table = value[select]; $emit('recepVal',displays) }" />  
                            

                        <v-tabs align="start" :key="displays.params.fromfield.table" background-color="blue lighten-5" v-model="tab2" v-if="displays.params.fromfield.table">
                        <v-tab> Filtres </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tabs-items v-model="tab2" class="pl-4">
                            <v-tab-item>

                                <Filtre                              
                                :filtre="displays.params.fromfield.filter"
                                :table="displays.params.fromfield.table"
                                @recepVal="(data) => {displays.params.fromfield.filter = data; $emit('recepVal',displays)}"
                                />
                            </v-tab-item>

                            <v-tab-item>
                                <p>Vous devez choisir l'objet, le corp et le titre du mail en nommant les valeurs du as en "objet", "corp" et "titre"</p>
                                <Fields
                                :table="displays.params.fromfield.table"
                                :champs="displays.params.fromfield.champs"
                                :filter="displays.params.fromfield.filter"
                                :modalKey="modalKey"
                                :page="page"
                                @recepVal="(data) => {displays.params.fromfield.champs = data; $emit('recepVal',displays)}"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                        </v-tabs>

                    </div>


                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>

              <v-tabs align="start" background-color="blue lighten-5" class="ma-3" v-model="tabAff">
                        <v-tab> Filtres </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tab> Adresses E-mail </v-tab>
                        <v-tabs-items v-model="tabAff" class="pl-4">
                            <v-tab-item>
                              Le filtre va permettre de construire la requete pour affilier les crochets situés dans le corp du mail afin de les remplacer par les valeurs de la requete
                                <Filtre
                                  :filtre="displays.filter"
                                  :table="module.table"
                                  @recepVal="changeFilter"
                                />
                            </v-tab-item>

                            <v-tab-item>
                              <p class="font-weight-medium">Veuillez nommer le AS des champs au nom des crochets pour affiliation. ex : {_nom_} = nom</p>

                              <v-btn @click="recupHooks">Récupérer les crochets pour affiliation</v-btn>

                              <div v-for="(list,i) in listHooks" :key="i" :class="['font-weight-bold',list.valid ? 'green--text':'red--text']"><span v-if="!list.valid">Affilier le crochet</span> {{ list.hook }} <span></span></div>

                              <Fields
                              :table="module.table"
                              :modalKey="modalKey"
                              :champs="displays.params.champs"
                              :filter="displays.filter"
                              :page="page"
                              @recepVal="(data) => {displays.params.champs = data; $emit('recepVal',displays); verifySync()}"
                              />
                            </v-tab-item>
                            <v-tab-item>
                              <p class="font-weight-medium">Vous pouvez intégrer une variable de requete par [[email||mon_AS]]</p>
                              
                              <TextField
                              :item="{ name: 'nom de l\'expéditeur', value: 'name' ,defaultprops:{ show: true }}"
                              :valField="displays.params.emailfrom.name"
                              :keyup="(item,model)=> { displays.params.emailfrom.name = model; $emit('recepVal',displays); }"
                              /> 
                              <TextField
                              :item="{ name: 'email de l\'expéditeur', value: 'from' ,defaultprops:{ show: true }}"
                              :valField="displays.params.emailfrom.from"
                              :keyup="(item,model)=> { displays.params.emailfrom.from = model; $emit('recepVal',displays); }"
                              /> 
                              <ArrayTable 
                                :item="{otherparams:{
                                    arrayTable:[
                                        {type:'',key:'adresse',name:'adresse e-mail'},                           
                                        {type:'',key:'alias',name:'alias'},
                                        {type:'select',key:'type',name:'emplacement',ArrayValue:[{text:'A',value:'a'},{text:'Cc',value:'cc'},{text:'Bcc',value:'bcc'}]}]}
                                ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajouter une adresse de destination'}}"
                                :valField="displays.params.emails"
                                :change="(item,value) => {displays.params.emails = value; $emit('recepVal',displays);}"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                        </v-tabs>





            </v-tab-item>
          <v-tab-item>
            <ArrayTable 
                    :item="{otherparams:{
                        arrayTable:[
                        {type:'select',key:'type',change:checkModule,name:'Type de document',ArrayValue:listDocAttach},
                            {type:'select',key:'module',name:'Module concerné',ArrayValue:listModule},                           
                            {type:'arraytable',key:'params',name:'Paramètres pour le module',
                              defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajout du paramètre'},
                                otherparams:{
                                  arrayTable:[
                                  {type:'',key:'key',name:'nom de la clé'},
                                  {type:'',key:'value',name:'Valeur de la clé',description:'Vous pouvez utiliser les variables [[params||ma_var]]'}
                                  ]
                                }

                          },
                          {type:'arraytable',key:'includecond',name:'Conditions d\'inclusion',
                              defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajout condition'},
                                otherparams:{
                                  arrayTable:[
                                  {type:'',key:'key',name:'si la valeur',description:'peut intégrer la variable email : [[email||mon_as]]'},
                                  {type:'select',key:'condition',name:'condition',ArrayValue:[{text:'est égal à',value:'='},{text:'est différent de',value:'!='},{text:'contient',value:'contein'}]},
                                  {type:'',key:'value',name:'Cette valeur',description:'Vous pouvez utiliser les variables [[params||ma_var]]'}
                                  ]
                                }

                          }]}
                    ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajouter un document d\'attachement'}}"
                    :valField="displays.params.attachement"
                    :change="(item,value) => {displays.params.attachement = value; $emit('recepVal',displays);}"
                    />
          </v-tab-item>


          <v-tab-item>
            <!-- envoi groupé-->
            <SwitchC
            :item="{ name: 'Activer l\'envoi groupé', value: 'right', defaultprops:{ show: true }}"
            :valField="displays.params.group.set"
            :change="(item,value) => {displays.params.group.set = value; $emit('recepVal',displays);}"
            />

            <div v-if="displays.params.group.set">
              <p>Construisez la requete permettant la liste de diffusion</p>
              <p>ATTENTION : en fonction du paramétrage du module et de la selection du corp, objet et PJ, les mails peuvent etre différents dans leurs contenus</p>
              <v-tabs align="start" background-color="blue lighten-5" class="ma-3" v-model="tab3">
                        <v-tab> Filtres </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tab> Visuel </v-tab>
                        <v-tab> Recherche </v-tab>
                        <v-tabs-items v-model="tab3" class="pl-4">
                            <v-tab-item>
                              <p class="font-weight-medium">Vous pouvez utiliser la variable 'line' issue de la requete pour emails et crochets : [[line||mon_as]]</p>
                                <Filtre
                                  :filtre="displays.params.group.query.filter"
                                  :table="module.table"
                                  @recepVal="(array) => {displays.params.group.query.filter = array; $emit('recepVal',displays)}"
                                />
                            </v-tab-item>

                            <v-tab-item>
                              <p class="font-weight-medium">Chaque AS correspondra à un nom de colonne du tableau.Il y aura une jonction automatique avec la table emailsent  </p>
                              <Fields
                              :table="module.table"
                              :modalKey="modalKey"
                              :champs="displays.params.group.query.champs"
                              :filter="displays.params.group.query.filter"
                              :page="page"
                              @recepVal="(data) => {displays.params.group.query.champs = data; $emit('recepVal',displays);}"
                              />
                            </v-tab-item>
                            <v-tab-item>
                              <v-alert type="info" text dense class="mt-3">
                                Composez les colonnes avec les variables <code>[[table||mon_alias]]</code> des champs de la liste.
                                Sans visuel, les colonnes historiques sont conservées.
                              </v-alert>
                              <Visuels
                                :visuels="displays.params.group.colonnes || []"
                                :fields="groupVisualFields"
                                :page="page"
                                :modalKey="modalKey"
                                @recepVal="changeGroupVisuals"
                              />
                            </v-tab-item>
                            <v-tab-item>
                              <v-alert type="info" text dense class="mt-3">
                                Choisissez les champs de recherche et leur AS dans la requête de groupe.
                                Ces filtres s'appliquent uniquement à cette liste, sans modifier la recherche de la page.
                              </v-alert>
                              <v-alert v-if="groupSearchCatalogError" type="error" text dense>
                                {{ groupSearchCatalogError }}
                                <v-btn small text @click="loadGroupSearchCatalog">Réessayer</v-btn>
                              </v-alert>
                              <v-row v-for="(mapping,index) in groupSearchMappings" :key="index" dense align="center">
                                <v-col cols="12" sm="6">
                                  <v-autocomplete :value="mapping.field" :items="groupSearchFieldOptions"
                                    :loading="groupSearchCatalogLoading" label="Champ du moteur" outlined dense hide-details
                                    @change="value => changeGroupSearchField(index,value)" />
                                </v-col>
                                <v-col cols="10" sm="5">
                                  <v-select :value="mapping.alias" :items="groupVisualFields" label="AS de la liste de groupe"
                                    outlined dense hide-details @change="value => changeGroupSearchAlias(index,value)" />
                                </v-col>
                                <v-col cols="2" sm="1" class="text-center">
                                  <v-btn icon small color="error" aria-label="Retirer ce filtre de recherche"
                                    @click="removeGroupSearchField(index)"><v-icon small>mdi-delete-outline</v-icon></v-btn>
                                </v-col>
                                <v-col v-if="mapping.alias && !groupVisualFields.includes(mapping.alias)" cols="12" class="text-caption error--text">
                                  Cet AS n'est plus présent dans les champs de la requête de groupe.
                                </v-col>
                                <v-col v-if="mapping.alias && groupSearchMappings.some((other,i) => i < index && other.alias === mapping.alias)" cols="12" class="text-caption error--text">
                                  Cet AS est déjà associé à un filtre. Seul le premier filtre sera utilisé.
                                </v-col>
                              </v-row>
                              <v-btn small outlined color="primary" class="my-3" @click="addGroupSearchField">
                                <v-icon small left>mdi-plus</v-icon>Ajouter un filtre de recherche
                              </v-btn>
                            </v-tab-item>
                        </v-tabs-items>
                        </v-tabs>            
            
            </div>
            

            </v-tab-item>

          </v-tabs-items>
        </v-tabs>
    </div>
    </v-card>
  </template>
  
  
  
  <script>
    import { admin } from '../mixins'; 
  export default {
    name: "SendEmail",

    mixins : [admin],

    components: {
      Visuels: () => import('../../engine/outils/constructVisuel/Visuel.vue'),
    },

  
    data: function () {
      return {

        displays: this.module.displays,
        typegenerate : '',
        manual : '',
        reload : 0,
        tab : null,
        tab2 : null,
        tab3 : null,
        tabAff : null,
        listPages : [],
        listFields : [],
        listHooks : [],
        listModule : [],
        groupSearchCatalog: [],
        groupSearchCatalogLoading: false,
        groupSearchCatalogError: '',
        groupSearchCatalogRequest: 0,
        listDocAttach : [{text:'Module PDF',value:'pdf'},{text:'Document interne',value:'docinterne'},{text:'Document GED',value:'ged'}],

      };
    },
  
    watch: {
      tab3(value) {
        if (value === 3) this.loadGroupSearchCatalog();
      },
      groupSearchCatalogKey() {
        this.groupSearchCatalogRequest++;
        this.groupSearchCatalogLoading = false;
        this.groupSearchCatalog = [];
        if (this.tab3 === 3) this.loadGroupSearchCatalog();
      },
  },
  
    computed: {
      groupSearchCatalogKey() {
        return JSON.stringify([this.module.table, this.displays.params.group.query.filter]);
      },
      groupSearchMappings() {
        return this.displays.params.group.search && this.displays.params.group.search.champs || [];
      },
      groupSearchFieldOptions() {
        return [...new Map(this.groupSearchCatalog.map(field => [field.cle, {
          value:field.cle, text:field.displays.name + ' (' + (field.alias || field.table) + '.' + field.field + ')',
        }])).values()];
      },
      groupVisualFields() {
        return [...new Set((this.displays.params.group.query.champs || []).map(field => field.as).filter(Boolean))];
      },
    },

    methods: {

      async loadGroupSearchCatalog() {
        if (this.groupSearchCatalogLoading) return;
        const requestId = ++this.groupSearchCatalogRequest;
        this.groupSearchCatalogLoading = true;
        this.groupSearchCatalogError = '';
        try {
          const response = await this.API({type:'post', url:'engine/module/getfieldswithjunctions',
            params:{table:this.module.table, filter:this.displays.params.group.query.filter}});
          if (requestId !== this.groupSearchCatalogRequest) return;
          if (!Array.isArray(response.data.fields)) throw new Error('Impossible de charger les champs de recherche.');
          this.groupSearchCatalog = response.data.fields;
        } catch (error) {
          if (requestId === this.groupSearchCatalogRequest) this.groupSearchCatalogError = error.message;
        } finally {
          if (requestId === this.groupSearchCatalogRequest) this.groupSearchCatalogLoading = false;
        }
      },

      saveGroupSearchMappings(mappings) {
        if (!this.displays.params.group.search) this.$set(this.displays.params.group, 'search', {champs:[]});
        this.$set(this.displays.params.group.search, 'champs', mappings);
        this.$emit('recepVal', this.displays);
      },

      addGroupSearchField() {
        this.saveGroupSearchMappings([...this.groupSearchMappings, {field:'', alias:''}]);
      },

      removeGroupSearchField(index) {
        this.saveGroupSearchMappings(this.groupSearchMappings.filter((mapping,i) => i !== index));
      },

      changeGroupSearchField(index, value) {
        const field = this.groupSearchCatalog.find(candidate => candidate.cle === value);
        const matching = field && this.displays.params.group.query.champs.find(column => column.type === 'field'
          && column.field === (field.alias || field.table) + '.' + field.field);
        this.saveGroupSearchMappings(this.groupSearchMappings.map((mapping,i) => i === index
          ? {...mapping, field:value, alias:matching ? matching.as : mapping.alias} : mapping));
      },

      changeGroupSearchAlias(index, value) {
        this.saveGroupSearchMappings(this.groupSearchMappings.map((mapping,i) => i === index ? {...mapping, alias:value} : mapping));
      },

      changeGroupVisuals(columns) {
        this.$set(this.displays.params.group, 'colonnes', columns);
        this.$emit('recepVal', this.displays);
      },

      checkModule(item,value,selectedKey) {
        if(value[selectedKey]=='ged' || value[selectedKey]=='pdf') {
          this.listModule = []
          this.API({ type: 'post', url: "/engine/module/list", params: { type: value[selectedKey] } }).then((resp) => {
            resp.data.forEach((v) => {
              this.listModule.push({ value: v.id, text: v.name });
            });
          })
        }

      },

        cc(item,value,selectedKey) {
            this.displays.params[item.value] = value[selectedKey]
            this.$emit('recepVal',this.displays)
        },

        recupHooks() {
          this.listHooks = []
          if(this.displays.params.type=='fromfield') {
            let isCorp = this.displays.params.fromfield.champs.find((el) => el.as =='corp')
            if(!this.displays.params.fromfield.table && !isCorp) {
                this.$toast.warning('Veuillez sélectionner la table et le corp dans l\'onglet corp de mail');
                return
            }

            this.getListField({filter:{table:this.displays.params.fromfield.table}}).then((resp) => {    
                var getVars = [] 
                
                            resp.forEach((field) => {
                                if(field.table+"."+field.field == isCorp.field) {
                                  // on update l'id du champ qui fait l'objet du corp, ca permettra de sortir ce champ si l'user veut modifier avant d'envoyer
                                  this.displays.params.fromfield.idField = field.id
                                  this.$emit('recepVal',this.displays)
                                    getVars = field.displays.otherparams.menueditor
                                    getVars.forEach((groupList) => {
                                        groupList.list.forEach((elem) => {
                                            if(elem.value!==null && elem.value!='') this.listHooks.push({hook:elem.value,valid:false})
                                        })
                                    })
                                }
                            })
                            this.verifySync();                                                                                                      
                        })
          }
          
          if(this.displays.params.type=='manual') {
            const resultats = this.displays.params.manual.corp.match(/\{_(.*?)_\}/g);
            if(Array.isArray(resultats)) resultats.forEach((elem) => { this.listHooks.push({hook:elem,valid:false}) })
          }

        },
        
        verifySync() {
            this.listHooks.forEach((hook,h)=> {
                this.listHooks[h].valid = false;
                let name = hook.hook.match(/{_([^}]+)_}/)[1];
                if(this.displays.params.champs.find((el) =>  el.as == name)) this.listHooks[h].valid = true;
            })
        },

      changeFilter(array) {
      this.displays.filter = array
      this.$emit('recepVal',this.displays)
    },

    changeEC(array) {
      this.displays.params.champs = array
      this.$emit('recepVal',this.displays)     
    },
  
    },
  
    mounted() {
            // permet de cibler le module pour lien de photo : //

            this.API({ type: 'post', url: "/engine/module/list", params: { type: 'bibliotheque' } }).then((resp) => {
                    resp.data.forEach((v) => {
                      this.listPages.push({ value: v.id, text: v.name });
                    });
                })
  
    },
  };
  </script>
